export const ACCESS_TOKEN_KEY = 'ACCESS_TOKEN_KEY';
export const BASE_API_URL = 'https://dev-api-edu.go.vn/demo-service';